module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Oblique.7371efa1.woff2";